module.exports = __webpack_public_path__ + "img/iconFile.45f3766d.svg";